import React from "react";
import Enrolment from "../Enrolment";

const EnrollmentSummaryComponent = () => {
  return <Enrolment status="summary" title="summary" />;
};

export default EnrollmentSummaryComponent;
